import client from './client';
import {
  MISC_COST_CATEGORIES,
  MiscCost,
  MiscCostCategory,
  MiscCostsResponse,
} from '../types/miscCost';

const EMPTY_BY_CATEGORY: Record<string, number> = Object.fromEntries(
  MISC_COST_CATEGORIES.map((c) => [c, 0])
);

export async function getMiscCosts(params: {
  from: string;
  to: string;
  category?: MiscCostCategory | '';
}): Promise<MiscCostsResponse> {
  const res = await client.get('/api/admin/misc-costs', {
    params: {
      from: params.from,
      to: params.to,
      // An empty category means "all" — sending it would 400 on the server.
      ...(params.category ? { category: params.category } : {}),
    },
  });
  const raw = res.data ?? {};
  const costs: MiscCost[] = Array.isArray(raw.costs) ? raw.costs : [];
  return {
    costs,
    summary: {
      total: raw.summary?.total ?? 0,
      count: raw.summary?.count ?? costs.length,
      by_category: { ...EMPTY_BY_CATEGORY, ...(raw.summary?.by_category ?? {}) },
    },
  };
}

export async function createMiscCost(input: {
  description: string;
  amount: number;
  category: MiscCostCategory;
  expense_date: string;
  receipt_ref?: string;
}): Promise<void> {
  await client.post('/api/admin/misc-costs', input);
}

export async function deleteMiscCost(id: string): Promise<void> {
  await client.delete(`/api/admin/misc-costs/${id}`);
}
